module.exports = __webpack_public_path__ + "media/body-condition/puppy-skinny-abff088d.svg";